import { render, staticRenderFns } from "./notaValePremios.vue?vue&type=template&id=5dd1b512&scoped=true&"
import script from "./notaValePremios.ts?vue&type=script&lang=ts&"
export * from "./notaValePremios.ts?vue&type=script&lang=ts&"
import style0 from "./notaValePremios.vue?vue&type=style&index=0&id=5dd1b512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd1b512",
  null
  
)

export default component.exports